import * as React from 'react';
import { useLingui } from '@lingui/react';
import { getGeSectionByName } from '../../../getters';

export const SectionHeading = (props: { sectionName: string }) => {
  const { sectionName, ...rest } = props;
  const sectionData = getGeSectionByName(sectionName);
  const {
    _,
  } = useLingui();
  if ('title' in sectionData) {
    return <>{_(sectionData.title)}</>;
  }
  if ('TitleComponent' in sectionData) {
    return <sectionData.TitleComponent {...rest} />;
  }
  return null;
};
